// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-style-page[data-v-378899c2]{font-size:14px!important;font-family:Times New Roman,Times,serif;padding:0 32px}.print-content[data-v-378899c2]{display:none}@media print{.not-print-content[data-v-378899c2]{display:none}.print-content[data-v-378899c2]{display:block}.custom-style-page[data-v-378899c2]{padding:0}}", ""]);
// Exports
module.exports = exports;
